import React from "react";

function LearnMore({ title = "Learn More" }) {
  return (
    <>
      <button className='bg-primary hover:bg-transparent hover:text-primary border border-primary px-3.5 py-1.5 rounded-full text-white'>
        {title}
      </button>
    </>
  );
}

export default LearnMore;
